import React from 'react';
import createReactClass from 'create-react-class';

import debounce from 'lodash/debounce';
import { registerField } from 'core/forms';
import { withContainer } from 'core/cache';

import getLocales from '../helpers/getLocales';
import { getTopics } from '../helpers/getMockData';

import TopicTagMapping from '../components/topicTagMapping';

const endpoint = '/api/admin/topics/locale_sections';

const defaultLocale = window.availableLocales?.[0].code;

const queries = {
  allTopics: { locale: defaultLocale },
  topics: { locale: defaultLocale, search_query: '' },
};

const FormFieldTopicTagMappingContainer = withContainer(createReactClass({
  getInitialState() {
    const { topics, value } = this.props;

    return { search: topics.query.search_query, topicSelection: value || [] };
  },

  componentDidMount() {
    this.search = debounce(this.search, 600);
  },

  componentWillUnmount() {
    Object.entries(queries).forEach(([prop, query]) => {
      this.props[prop].setQuery(query);
    });
  },

  handleLocaleChange({ value: locale }) {
    const { allTopics, topics } = this.props;

    allTopics.setQuery({ locale });
    topics.setQuery({ locale }, { setType: 'extend' });
    allTopics.fetch();
    topics.fetch();
  },

  handleSearchInputChange(search) {
    this.setState({ search });
    this.props.topics.setQuery({ search_query: search }, { setType: 'extend' });
    this.search();
  },

  handleTopicSelectionUpdate(topicSelection) {
    this.setState({ topicSelection });
    this.props.updateField(topicSelection);
  },

  search() {
    this.props.topics.fetch();
  },

  render() {
    const { allTopics, schema, topics } = this.props;
    const { search, topicSelection } = this.state;
    const { query } = topics;

    return (
      <TopicTagMapping
        allTopics={allTopics.data}
        hasSearch={Boolean(query.search_query)}
        isInitiallyExpanded={schema.isInitiallyExpanded}
        isLoading={allTopics.status !== 'success' || topics.status !== 'success'}
        locale={query.locale}
        locales={getLocales()}
        onLocaleChange={this.handleLocaleChange}
        onSearchInputChange={this.handleSearchInputChange}
        onTopicSelectionUpdate={this.handleTopicSelectionUpdate}
        searchInputValue={search}
        topics={topics.data}
        topicSelection={topicSelection}
      />
    );
  },
}), {
  cache: {
    allTopics: {
      getMockedResponse: () => ({ data: getTopics() }),
      initialData: [],
      isMocked: false,
      query: queries.allTopics,
      transform: ({ data }) => data.data,
      url: endpoint,
    },
    topics: {
      getMockedResponse: () => ({ data: getTopics() }),
      initialData: [],
      isMocked: false,
      query: queries.topics,
      transform: ({ data }) => data.data,
      url: endpoint,
    },
  },
});

registerField('TopicTagMapping', FormFieldTopicTagMappingContainer);

export default FormFieldTopicTagMappingContainer;
